/* eslint-disable */

import React from "react";
import "./App.scss";

import withSizes from "react-sizes";

import { getLambdaEndpoint } from "../../helpers/lambdaHelper";

import HeEPSDownloadReport from "../../components/HeEPS/DownloadReport";
import GeoList from "../../components/HeEPS/GeoList";
import HeModal from "../../components/HeModal";
import HeSearch from "../../components/HeSearch";
import HeSelect from "../../components/HeSelect";

import HeMapboxUrbica from "../../components/HeMapboxUrbica";
import CensusLayer from "../../components/HeMapboxUrbica/components/CensusLayer";
import Popup from "../../components/HeMapboxUrbica/components/Popup";

import ZoomInWarning from "../../components/HeMapboxUrbica/components/ZoomInWarning";
import HeAppWrapper from "../../components/HeAppWrapper";

import { geoLayers } from "./layers";
import colors from "./colors";

import throttle from "lodash/throttle";
import cloneDeep from "lodash/cloneDeep";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import unionBy from "lodash/unionBy";
import queryString from "query-string";
import filter from "lodash/filter";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload, faPlus } from "@fortawesome/free-solid-svg-icons";
import { faSquare } from "@fortawesome/free-regular-svg-icons";

// let webRoot = document.location.hostname === "localhost" ? "http://localhost:9999" : "";

// // define global variables
// let he_tools, jQuery, ol;
// let tipobj;

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedGeos: [],
            visibleGeoLayer: "state",
            // benchmarkGeos: [],
            isMounted: false,
            // customLayerStyles: customLayerStyles,
            mapExtent: {
                maxLat: 50,
                maxLon: -65,
                minLat: 25,
                minLon: -125,
            },
            hoveredFeatureProps: null,
            currentMapExtent: null,
            // popupContent: null,
            downloadModalOpen: false,
            benchmarkGeo: { id: "0", label: "United States" },
            instructionsDisplayed: false,
        };
        // this.updateCustomLayerStyles = throttle(this.updateCustomLayerStyles.bind(this), 100);
        // this.handleExtentUpdate = throttle(this.handleExtentUpdate.bind(this), 500);
        // this.onFeatureHover = this.onFeatureHover.bind(this);
        this.onFeatureClick = this.onFeatureClick.bind(this);
        this.clearGeos = this.clearGeos.bind(this);
        this.handleBenchmarkGeoUpdate = this.handleBenchmarkGeoUpdate.bind(this);
    }

    componentDidMount() {
        this.setState({ isMounted: true });
    }

    // onFeatureHover(featureProps) {
    //     if (!this.state.hoveredFeatureProps || featureProps.id !== this.state.hoveredFeatureProps.id) {
    //         this.setState(
    //             {
    //                 hoveredFeatureProps: featureProps,
    //             }
    //         );
    //     }
    // }
    onFeatureClick(feature) {
        if (findIndex(this.state.selectedGeos, { id: feature.id }) > -1) {
            this.removeGeo(feature.id);
        } else {
            this.addGeo(feature.id, feature.properties.name, this.state.visibleGeoLayer);
        }
    }

    makeGeo(id, name, layerId) {
        return {
            id: id,
            label: name,
            name: name,
            layerId: layerId,
            geo_level: this.state.visibleGeoLayer,
        };
    }
    addGeo(id, name, layerId) {
        if (findIndex(this.state.selectedGeos, { id: id }) > -1) return;
        const newGeo = this.makeGeo(id, name, layerId);
        const selectedGeos = unionBy(this.state.selectedGeos, [newGeo]);

        let newState = { selectedGeos };
        this.setState(newState, this.updateCustomLayerStyles);
    }

    extentsEqual(extent1, extent2) {
        let eq = true;
        ["minLat", "minLon", "maxLat", "maxLon"].forEach((dim) => {
            if (extent1[dim] !== extent2[dim]) {
                eq = false;
            }
        });
        return eq;
    }

    removeGeo(id) {
        this.setState({
            selectedGeos: filter(this.state.selectedGeos, (selectedGeo) => {
                return selectedGeo.id !== id;
            }),
            highlightedGeo: null,
        });
    }
    clearGeos() {
        this.setState({ selectedGeos: [] });
    }

    handleChangeGeoLayer(newGeoLayerId) {
        let mapCursor_isHovering = "pointer";
        this.setState({
            hoverLayer: newGeoLayerId,
            visibleGeoLayer: newGeoLayerId,
            mapCursor_isHovering: mapCursor_isHovering,
        });
    }
    PopupContent() {
        if (!this.state.hoveredFeatureProps) return null;

        const frag_header = () => {
            return <div className="dheader">{this.state.hoveredFeatureProps.name}</div>;
        };
        const frag_instructions = () => {
            const addOrRemove =
                findIndex(this.state.selectedGeos, { id: this.state.hoveredFeatureProps.id }) > -1 ? "remove" : "add";
            return (
                <div className="dtext">
                    Click to <b>{addOrRemove}</b>
                </div>
            );
        };

        return (
            <>
                {frag_header()}
                {frag_instructions()}
            </>
        );
    }
    render() {
        return (
            <HeAppWrapper className="app-populations-at-risk">
                {this.renderInstructions()}
                <div style={{ border: "1px solid silver" }}>
                    <div className="searchContainer">{this.renderSearch()}</div>
                    <div
                        className="mainContainer"
                        style={{
                            display: "grid",
                            gridTemplateColumns: this.props.screenSize === "large" ? "auto 300px" : "auto",
                        }}
                    >
                        <div className="mapContainer">{this.renderMap()}</div>
                        <div className="selectedLocationsContainer">{this.renderSelectedLocations()}</div>
                    </div>
                </div>
                {this.renderFooter()}
                {/* {renderRegionalModal()}
                {renderBenchmarkModal()}
                {renderDataAlertModal()}
                {renderInfoModal()}
                {renderGeneralAlertModal()}
                {renderReportBuildForm()} */}
            </HeAppWrapper>
        );
    }
    renderInstructions() {
        let maxHeight = this.state.instructionsDisplayed ? 350 : 0;
        let rotation = this.state.instructionsDisplayed ? "45deg" : "0deg";
        return (
            <div
                id="par-help-expand"
                onClick={() => {
                    this.setState({ instructionsDisplayed: !this.state.instructionsDisplayed });
                }}
                className={"par-section par-section-even"}
                style={{ position: "relative", minHeight: "auto", cursor: "pointer" }}
            >
                <div class="par-expand-plus-sign" style={{ position: "absolute", top: 20, left: 7 }}>
                    <span className="fa-layers" style={{ color: "rgb(22, 100, 128)" }}>
                        <FontAwesomeIcon
                            className="fa-fw plus-sign"
                            icon={faPlus}
                            style={{ width: 28, fontSize: 18, transform: "rotate(" + rotation + ")" }}
                        />
                        <FontAwesomeIcon className="fa-fw" icon={faSquare} style={{ width: 28, fontSize: 28 }} />
                    </span>
                    {/* <img
                        src="https://headwaterseconomics.org/wp-content/uploads/icon-par-help-expand.png"
                        width="23"
                        height="24"
                        className="alignnone size-full wp-image-21212"
                    /> */}
                </div>
                <div
                    className="tools-input-row par-color font-bolder"
                    style={{
                        paddingLeft: 20,
                        display: this.props.screenSize === "small" ? "block" : "grid",
                        gridTemplateColumns: "33% 33% auto",
                    }}
                >
                    <div className="par-step">
                        <div className="font-bigger text-up">Step 1:</div>
                        <div className="text-up">Enter Location(s)</div>
                        <div className="par-help-content" style={{ maxHeight: maxHeight, paddingRight: 10 }}>
                            <img
                                src="https://headwaterseconomics.org/wp-content/uploads/par-step-1.png"
                                width="295"
                                height="175"
                                className="alignnone size-full wp-image-21213 margin-top"
                            />
                            <p></p>
                            <div className="font-small">
                                Enter location name, and select your choice from the dropdown menu.
                                <span className="par-color-2">Ex. Chicago, Cook County, or Illinois</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="font-bigger text-up">Step 2:</div>
                        <div className="text-up">Download Report</div>
                        <div className="par-help-content" style={{ maxHeight: maxHeight, paddingRight: 10 }}>
                            <img
                                src="https://headwaterseconomics.org/wp-content/uploads/par-step-2.png"
                                width="295"
                                height="187"
                                className="alignnone size-full wp-image-21214 margin-top"
                            />
                            <p></p>
                            <div className="font-small">
                                Click the <span className="text-up">“Download Report”</span> button. The tool will
                                generate a report for you.{" "}
                                <span className="par-color-2">
                                    Check your download folder if the report does not open.
                                </span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="font-bigger text-up">Customize</div>
                        <div className="text-up">Reports</div>
                        <div className="par-help-content" style={{ maxHeight: maxHeight }}>
                            <div className="margin-top" style={{ marginBottom: "4em" }}>
                                <ul>
                                    <li>
                                        <a
                                            href="/tools/populations-at-risk/about/#search-by-type"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Search by type of location
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="/tools/populations-at-risk/about/#compare-multiple-locations"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Compare more than one location
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="/tools/populations-at-risk/about/#change-benchmark"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Change Benchmark Geography
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="/tools/populations-at-risk/about/#additional-tips"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Additional user tips
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <p className="text-right">
                                <a
                                    href="/tools/populations-at-risk/about/#help"
                                    target="_blank"
                                    className="par-large par-large-learn"
                                    rel="noopener noreferrer"
                                >
                                    Need More Help? &gt;&gt;
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    renderFooter() {
        return (
            <div className="par-section par-section-even par-buttons">
                <a href="/tools/populations-at-risk/faq/" class="par-large par-large-learn">
                    FAQ
                </a>
                <a href="/tools/populations-at-risk/about/#help" class="par-large par-large-learn">
                    Help
                </a>
            </div>
        );
    }

    renderSearch() {
        return (
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: this.props.screenSize === "small" ? "auto" : "50% 50%",
                    gridTemplateRows: "20px 40px",
                }}
            >
                <div className="tools-input-header">Enter location(s):</div>
                <div
                    style={{
                        paddingRight: this.props.screenSize === "large" ? 20 : 0,
                        gridRow: 2,
                    }}
                >
                    <HeSearch
                        style={{ width: "100%" }}
                        geoTypes={"he-nation,he-portion,he-place,he-county,he-state"}
                        placeholder={"ex. San Diego, Broward County, Minnesota"}
                        onSelect={(value) => {
                            this.zoomToGeo(value);
                        }}
                        clearOnClick={true}
                        clearOnSelect={false}
                        noResultsMessage={"No results"}
                        defaultStyle={false}
                    />
                </div>

                <div className="tools-input-header">Select type of location(s):</div>
                <div>
                    <HeSelect
                        data={geoLayers.map((geoLayer) => {
                            return { value: geoLayer.id, label: geoLayer.label };
                        })}
                        onChange={(val) => {
                            this.handleChangeGeoLayer(val.value);
                        }}
                        selected={this.state.visibleGeoLayer}
                        defaultStyle={false}
                    />
                </div>
            </div>
        );
    }
    zoomToGeo(geo) {
        let _this = this;
        let url = getLambdaEndpoint() + "?";
        url += queryString.stringify({
            flavor: "fetchExtentOfGeo",
            geoType: geo.owner + "-" + geo.geo_level,
            id: geo.id,
        });
        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                if (!data.message || data.message !== "Internal server error") {
                    this.setState({ mapExtent: data.data, visibleGeoLayer: geo.geo_level }, () => {
                        _this.addGeo(geo.id, geo.label, geo.geo_level);
                    });

                    // dispatch({ type: actions.SET_MAP_EXTENT, to: data.data });
                }
            });
    }

    renderMap() {
        let mapWidth = 400;
        if (this.props.screenSize === "large") {
            mapWidth = this.props.appWidth - 330;
        } else {
            mapWidth = this.props.appWidth - 20;
        }

        return (
            <HeMapboxUrbica extent={this.state.mapExtent}>
                <ZoomInWarning activeMapLayer={this.state.visibleGeoLayer} />
                {this.state.hoveredFeatureProps && (
                    <Popup closeButton={false} closeOnClick={false} maxWidth="600px">
                        {this.PopupContent()}
                    </Popup>
                )}
                <CensusLayer
                    layerName={this.state.visibleGeoLayer}
                    before="housenum-label"
                    color_default_border={colors.geo_default_stroke}
                    color_default_fill={colors.geo_default_fill}
                    color_hover_border={colors.geo_highlight_stroke}
                    color_hover_fill={colors.geo_highlight_fill}
                    color_select_border={colors.geo_selected_stroke}
                    color_select_fill={colors.geo_selected_fill}
                    onClick={this.onFeatureClick}
                    onHover={(ftr) => {
                        this.setState({ hoveredFeatureProps: !ftr ? null : { id: ftr.id, name: ftr.properties.name } });
                    }}
                    selectedFeatures={this.state.selectedGeos.map((sg) => ({
                        id: sg.id,
                        geo_level: sg.geo_level,
                    }))}
                    color_label={"rgb(143, 43, 0)"}
                    lineWidth_selectLayer={3}
                    suppressLabels={false}
                />
            </HeMapboxUrbica>
        );
    }
    handleBenchmarkGeoUpdate(newBenchmark) {
        this.setState({ benchmarkGeo: newBenchmark });
    }

    renderSelectedLocations() {
        return (
            <div style={{ paddingLeft: 10, borderLeft: "1px solid silver" }}>
                <div className="tools-geo-list-head">Selected Locations</div>
                <div id="selected-geos-container" className="selected-geos tools-geo-list-items">
                    {this.state.selectedGeos.length === 0 ? (
                        <span className="selected-geos-placeholder">
                            Please select at least one location to download a report.
                        </span>
                    ) : null}
                    {[{ id: "nation", label: "Nation" }].concat(geoLayers).map((geoLayer) => {
                        const geosOfType = this.state.selectedGeos.filter((geo) => {
                            return geoLayer.id === geo.layerId;
                        });
                        if (geosOfType.length === 0) return null;
                        return (
                            <div>
                                <span className="selected-geo-level">{geoLayer.label}</span>
                                <GeoList
                                    selectedGeos={geosOfType}
                                    dataAlerts={[]}
                                    removeGeo={(geoId) => {
                                        this.removeGeo(geoId);
                                    }}
                                />
                            </div>
                        );
                    })}
                </div>
                <div className="tools-clear-geos">
                    <button id="clear_geos" className="tools-geo-clear reset" onClick={this.clearGeos}>
                        Reset
                    </button>
                </div>
                {this.state.selectedGeos.length > 50 && (
                    <div style={{ color: "red" }}>
                        The maximum number of geographies supported by this download is 50.{" "}
                    </div>
                )}
                <div>
                    <div id="check-download" className="download-progress-icon" style={{ display: "none" }}></div>
                    <button
                        name="download_report"
                        id="download_report"
                        className="tool-button-download active"
                        disabled={this.state.selectedGeos.length === 0 || this.state.selectedGeos.length > 50}
                        onClick={() => {
                            this.setState({ downloadModalOpen: true, fontSize: 20 });
                        }}
                    >
                        <FontAwesomeIcon icon={faFileDownload} style={{ marginRight: 5 }} /> Download Report
                    </button>
                    <HeModal
                        className="app"
                        headerText="Download Report"
                        headerFontAwesomeIcon={<FontAwesomeIcon icon={faFileDownload} style={{ color: "#367ebd" }} />}
                        isOpen={this.state.downloadModalOpen}
                        onCloseRequest={() => this.setState({ downloadModalOpen: false })}
                        onDownloadRequest={() => {
                            this.child.submitViaCors();
                        }}
                        buttonClass="app_button"
                        content={
                            <div className="app reportrequest">
                                <HeEPSDownloadReport
                                    TemplateName={"par"}
                                    requestSource="populations-at-risk"
                                    excelOnly={this.state.selectedGeos.length > 5}
                                    Group1_geoCodes={this.state.selectedGeos.map((geo) => {
                                        return geo.id;
                                    })}
                                    Group1_Aggregate={false}
                                    Group1_Region={false}
                                    Group1_Benchmark={false}
                                    Group2_overrideName={
                                        this.state.selectedGeos.length === 1
                                            ? this.state.selectedGeos[0].label
                                            : "Combined " + find(geoLayers, { id: this.state.visibleGeoLayer }).label
                                    }
                                    Group3_overrideName={this.state.benchmarkGeo.label}
                                    printFormat="pdf"
                                    defaultTitle="Populations At Risk"
                                    // defaultSubTitle={this.state.selectedGeos.length === 1 ? this.state.selectedGeos[0].label : "Selected " + find(geoLayers, { id: this.state.visibleGeoLayer }).label}
                                    hideSubtitleField={true}
                                    onRef={(ref) => (this.child = ref)}
                                    benchmarkGeo={this.state.benchmarkGeo}
                                    onBenchmarkGeoUpdate={this.handleBenchmarkGeoUpdate}
                                />
                            </div>
                        }
                    />
                </div>
            </div>
        );
    }
}

const mapSizesToProps = ({ width, height }) => ({
    screenSize: width > 800 ? "large" : "small",
    appWidth: width,
    appHeight: height,
});

export default withSizes(mapSizesToProps)(App);
